'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var reactRouterDom = require('react-router-dom');
var DeleteSharpIcon = _interopDefault(require('@mui/icons-material/DeleteSharp'));
var CreateIcon = _interopDefault(require('@mui/icons-material/Create'));

const RenderEditAction = ({
  row: {
    id
  },
  value
}) => {
  const {
    url
  } = reactRouterDom.useRouteMatch();
  const to = `${url}/${id}`;
  return React.createElement(reactRouterDom.Link, {
    to: to
  }, React.createElement(CreateIcon, null), value);
};
const RenderDeleteAction = ({
  value
}) => {
  return React.createElement("button", null, React.createElement(DeleteSharpIcon, null), value);
};

exports.RenderDeleteAction = RenderDeleteAction;
exports.RenderEditAction = RenderEditAction;
//# sourceMappingURL=index.js.map
